var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommonGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5417 50.7503H15.7083C13.05 50.7503 10.875 48.5753 10.875 45.917V21.7503C10.875 19.092 13.05 16.917 15.7083 16.917H49.5417C52.2 16.917 54.375 19.092 54.375 21.7503V45.917C54.375 48.5753 52.2 50.7503 49.5417 50.7503Z",
    fill: "#6157FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2917 43.5003H8.45833C5.8 43.5003 3.625 41.3253 3.625 38.667V14.5003C3.625 11.842 5.8 9.66699 8.45833 9.66699H42.2917C44.95 9.66699 47.125 11.842 47.125 14.5003V38.667C47.125 41.3253 44.95 43.5003 42.2917 43.5003Z",
    fill: "#ABB4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 22.958C38.252 22.958 39.875 21.335 39.875 19.333C39.875 17.331 38.252 15.708 36.25 15.708C34.248 15.708 32.625 17.331 32.625 19.333C32.625 21.335 34.248 22.958 36.25 22.958Z",
    fill: "#FFE7CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5416 21.6289L9.66663 37.4581H31.4166L20.5416 21.6289Z",
    fill: "#4E44DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8334 28.3955L26.5834 37.458H41.0834L33.8334 28.3955Z",
    fill: "#F1F4FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonGallery);
export default __webpack_public_path__ + "static/media/common_gallery.a063f15903e014011ba188c7996f02d7.svg";
export { ForwardRef as ReactComponent };